import { useEffect, useState } from "react";
import { Link, useNavigate, Outlet, useLocation } from "react-router-dom";
import { masterAuth, masterFetch } from "./masterApi";

const NAV = [
  { to: "/master", label: "Dashboard", end: true },
  { to: "/master/tenants", label: "Tenants" },
  { to: "/master/operator-hours", label: "Operator hours" },
  { to: "/master/image-guardians", label: "Image guardians" },
  { to: "/master/plans", label: "Plans" },
  { to: "/master/compliance", label: "Compliance" },
  { to: "/master/support", label: "Support chat" },
  { to: "/master/reports", label: "Reports" },
  { to: "/master/audit", label: "Audit log" },
  { to: "/master/settings", label: "Settings" },
];

export default function MasterLayout({ children }) {
  const nav = useNavigate();
  const loc = useLocation();
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    if (!masterAuth.isLoggedIn()) {
      nav("/master/login", { replace: true });
      return;
    }
    masterFetch("/dashboard").then(() => setBootstrapped(true)).catch(() => {});
  }, [nav]);

  if (!masterAuth.isLoggedIn()) return null;

  const logout = () => {
    masterAuth.clear();
    nav("/master/login", { replace: true });
  };

  return (
    <div
      data-testid="master-shell"
      style={{
        minHeight: "100vh",
        background: "#06050d",
        color: "#e9e6f2",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        display: "grid",
        gridTemplateColumns: "240px 1fr",
      }}
    >
      <aside
        style={{
          background: "linear-gradient(180deg, #110720 0%, #06050d 100%)",
          borderRight: "1px solid #1f1232",
          padding: "26px 18px",
        }}
      >
        <div style={{ fontSize: 11, letterSpacing: 3, opacity: 0.5 }}>PLATFORM</div>
        <div style={{ fontSize: 18, fontWeight: 600, margin: "4px 0 26px" }}>Master Console</div>
        <nav style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {NAV.map((n) => {
            const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`master-nav-${n.label.toLowerCase().replace(" ", "-")}`}
                style={{
                  padding: "10px 12px",
                  borderRadius: 8,
                  textDecoration: "none",
                  color: active ? "#fff" : "#a89ec9",
                  background: active ? "rgba(139,92,246,0.18)" : "transparent",
                  fontSize: 13,
                  letterSpacing: 0.5,
                  border: active ? "1px solid rgba(139,92,246,0.4)" : "1px solid transparent",
                }}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>
        <button
          data-testid="master-logout"
          onClick={logout}
          style={{
            marginTop: 26,
            padding: "9px 12px",
            background: "transparent",
            border: "1px solid #3a2a55",
            color: "#a89ec9",
            borderRadius: 8,
            cursor: "pointer",
            fontSize: 12,
            letterSpacing: 1,
            width: "100%",
          }}
        >
          Sign out
        </button>
      </aside>
      <main style={{ padding: "32px 44px", maxWidth: 1280 }}>
        {bootstrapped ? children || <Outlet /> : <div style={{ opacity: 0.5 }}>Loading…</div>}
      </main>
    </div>
  );
}
